import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WebAccessScreen } from './web-access.component';
import { CxFormsModule } from '@forms';
import { WebAccessService } from './web-access.service';
import { WebAccessConditionalLink } from './web-access.conditional-link';
import { WebAccessDynamicExternalLink } from './web-access.dynamic-external-link';

@NgModule({
    imports: [
        CommonModule,
        CxFormsModule
    ],
    declarations: [
        WebAccessScreen
    ],
    exports: [
        WebAccessScreen
    ],
    providers: [
        WebAccessService,
        WebAccessConditionalLink,
        WebAccessDynamicExternalLink
    ]
})
export class WebAccessModule {
}

export {
    WebAccessScreen,
    WebAccessService,
    WebAccessConditionalLink,
    WebAccessDynamicExternalLink
};
